/* eslint-disable react-hooks/rules-of-hooks */
import './AddPermissionsForm.css'
import CustomInput from "../CustomInput/CustomInput";
import CustomBtn from "../CustomBtn/CustomBtn";
import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

// import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { values } from 'pdf-lib';

function index() {
  const { id } = useParams();
  console.log(id);

  const userinfo = useSelector((state) => state);
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const navigate = useNavigate();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [type_id, setType_id] = useState("");

  const [name, setName] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [email, setEmail] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [password, setPssword] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [phone, setPhone] = useState('')

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [loading, setLoading] = useState(false)
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [jobTitle, setJobTitle] = useState("")
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [roleData, setRoleData] = useState([])
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [employeesList, setEmployeesList] = useState([])
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [items, setItems] = useState([])
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [employe, setEmploye] = useState("")
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [employeeData, setEmployeeData] = useState(null)
  const [selected, setSelected] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [roles, setRole] = useState([])
  useEffect(() => {
    const getAllApis = async () => {

      await axios
        .get(`https://nanosoft.space/taarteb/public/api/admin/employee-roles`, {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
          }
        })
        .then(async (res) => {

          const nameMap = {
            "Financial Director": currentLocal.home.Financialofficer,
            "Sales Employee": currentLocal.home.salesemployee,
            "Purchasing Employee": currentLocal.home.Purchasingemployee,
                        "Teacher": currentLocal.home.teacher,

            "Salaries Employee": currentLocal.home.Salariesemployee,
            "Maintenance Employee": currentLocal.home.Maintenanceemployee,
            "Other": currentLocal.home.Other,
                        "DataEntry": currentLocal.home.DataEntry,


          };

          const translatedData = res.data.data?.map((role) => ({
            ...role,
            name: nameMap[role.name] || role.name, // fallback to English if no translation
          }));
          const roleOptions = translatedData?.map(item => ({
            value: item.id,
            label: item.name
          }));

          setRole(roleOptions)


        })
        .catch((error) => {





        });
      await axios
        .get(`https://nanosoft.space/taarteb/public/api/admin/employees`, {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
          }
        })
        .then(async (res) => {
          setEmployeesList(res.data.data.data);
          const customData = res.data.data.data?.find((item) => item?.id == id)
          setEmploye({ value: id, label: customData?.name })
          setName(customData?.name)
          setEmail(customData?.email)
          setPhone(customData?.phone)
          setJobTitle(customData?.job_title)
          const nameMap = {
            "Financial Director": currentLocal.home.Financialofficer,
            "Sales Employee": currentLocal.home.salesemployee,
            "Purchasing Employee": currentLocal.home.Purchasingemployee,
            "Teacher": currentLocal.home.teacher,
            "Salaries Employee": currentLocal.home.Salariesemployee,
            "Maintenance Employee": currentLocal.home.Maintenanceemployee,
            "Other": currentLocal.home.Other,
                        "DataEntry": currentLocal.home.DataEntry,


          };
          // const rolesOptions = customData?.roles.map(role => ({
          //   label: nameMap[customData.role] || customData.role,
          //   value: role.id
          // }));
          const rolesOptions = customData?.roles?.map(role => ({
            label: nameMap[role.name] || role.name,
            value: role.id
          }));

          setSelectedRoles(rolesOptions);

          setRoleData(rolesOptions)


          const translatedEmployees = res.data.data.data.map((emp) => ({
            ...emp,
            role: nameMap[emp.role] || emp.role, // translate main role
            roles: emp.roles?.map((r) => ({
              ...r,
              name: nameMap[r.name] || r.name, // translate nested role
            })),
          }));

          const roleOptions = translatedEmployees?.map(item => ({
            value: item.id,
            label: item.name
          }));

          const rolesData = translatedEmployees?.find((item) => item?.id == employe?.value)
          console.log(roleOptions);

          setEmployeeData(rolesData)
          setItems(roleOptions)

        })
        .catch((error) => {


        });
    }
    getAllApis()

  }, [])
  const handleEmployeeChange = (selected) => {
    setEmploye(selected)

    const selectedEmployee = employeesList?.find(
      (item) => item.id === selected.value
    )

    setEmployeeData(selectedEmployee)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const payload = {
      password: password && password,
      job_title: jobTitle && jobTitle,
      name: name && name,
      phone: phone && phone,
      email: email && email,
      password: password && password,
    }
    selectedRoles.forEach((r, index) => {
      payload[`role_ids[${index}]`] = r.value;
    });

    try {
      const response = await axios.post(id ? `https://nanosoft.space/taarteb/public/api/admin/employees/${id}` : `https://nanosoft.space/taarteb/public/api/admin/employees`, payload, {
        headers: {
          Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
          "Content-Type": "multipart/form-data",

        }
      });


      toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });
      setLoading(false);

      navigate('/dashboard/permissions')

    } catch (error) {
      toast.error(Object.values(error.response.data.errors)[0][0], { position: "bottom-right", autoClose: 3000 });
      setLoading(false);


    } finally {
      setLoading(false);
    }




  };





  return (
    <div className='add_student_form_container'>
      <ToastContainer />

      <form className='form_container'>
        <Container fluid>
          <Row>
            <Col md={6}>
              <div>
                <label>{currentLocal.home.namePlaceholder}</label>
                <CustomInput
                  placeholder={currentLocal.home.namePlaceholder}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label>{currentLocal.home.emailPlaceholder}</label>
                <CustomInput
                  placeholder={currentLocal.home.emailPlaceholder}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label>{currentLocal.home.phonePlaceholder}</label>
                <CustomInput
                  placeholder={currentLocal.home.phonePlaceholder}
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />

              </div>
            </Col>

            {roleData != undefined && roleData?.length != 0 ?
              <Col md={6}>
                <div>
                  <label>{currentLocal.home.permissions}</label>
                  <br />
                  <div className='mb-3'>
                    <Select
                      options={roles}
                      isMulti
                      value={selectedRoles ? selectedRoles : roleData}
                      onChange={setSelectedRoles}
                      placeholder={currentLocal.home.selectpermissions}
                    />
                    {/* <Select
                        value={type_id ?type_id: itemData}
                        onChange={(selectedOption) => setType_id(selectedOption)}
                        options={roles}
                        placeholder={currentLocal.home.selectpermissions} // Change this text

                      /> */}
                  </div>
                </div>
              </Col>



              :
              <Col md={6}>
                <div>
                  <label>{currentLocal.home.permissions}</label>
                  <br />
                  <div className='mb-3'>
                    <Select
                      options={roles}
                      isMulti
                      value={selectedRoles}
                      onChange={setSelectedRoles}
                      placeholder={currentLocal.home.selectpermissions}
                    />
                    {/* <Select
                      value={type_id}
                      onChange={(selectedOption) => setType_id(selectedOption)}
                      options={roles}
                      placeholder={currentLocal.home.selectpermissions} // Change this text

                    /> */}
                  </div>
                </div>
              </Col>
            }


            {selectedRoles?.find((iitem) => iitem.value == 26) &&
              <Col md={6}>
                <div>
                  <label>{currentLocal.home.jobTitle}</label>
                  <CustomInput
                    placeholder={currentLocal.home.jobTitle}
                    value={jobTitle}
                    onChange={(e) => setJobTitle(e.target.value)}
                  />
                </div>
              </Col>
            }

            {!id && selectedRoles?.find((iitem) => iitem.value != 26) &&

              <Col md={6}>
                <div>
                  <label>{currentLocal.home.passwordPlaceholder}</label>
                  <CustomInput
                    placeholder={currentLocal.home.passwordPlaceholder}
                    value={password}
                    onChange={(e) => setPssword(e.target.value)}
                  />
                </div>
              </Col>
            }

            <Col md={12}>
              <div className='d-flex justify-content-center mt-4 '>
                <div className='w-50 d-flex justify-content-center'>
                  <CustomBtn text={loading ? currentLocal.home.Loading : id ? currentLocal.home.editpermissions : currentLocal.home.Addpermissions} disabled={loading} clickingFunction={handleSubmit} />

                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </form>
    </div>
  )
}


export default index
